module.exports = __webpack_public_path__ + "img/icon3.a550e476.jpg";